module.exports = __webpack_public_path__ + "b8b7947c79045148c76941c344629cf3.pdf";